// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-otp-input {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0.5rem 0;
  position: relative;
}
:where(.vuetify-styles) .v-otp-input {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-otp-input .v-field {
  height: 100%;
}
:where(.vuetify-styles) .v-otp-input .v-field .v-field__outline__start, :where(.vuetify-styles) .v-otp-input .v-field .v-field__outline__end {
  flex: 1;
}
:where(.vuetify-styles) .v-otp-input .v-field input::placeholder {
  color: currentColor;
  opacity: var(--v-disabled-opacity);
}
:where(.vuetify-styles) .v-otp-input .v-field.v-field--focused input::placeholder {
  opacity: 0;
}

:where(.vuetify-styles) .v-otp-input__divider {
  margin: 0 8px;
}

:where(.vuetify-styles) .v-otp-input__content {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
  justify-content: center;
  max-width: 320px;
  position: relative;
  border-radius: inherit;
}
:where(.vuetify-styles) .v-otp-input--divided .v-otp-input__content {
  max-width: 360px;
}

:where(.vuetify-styles) .v-otp-input--density-default .v-otp-input__content {
  height: 64px;
}

:where(.vuetify-styles) .v-otp-input--density-comfortable .v-otp-input__content {
  height: 60px;
}

:where(.vuetify-styles) .v-otp-input--density-compact .v-otp-input__content {
  height: 56px;
}

:where(.vuetify-styles) .v-otp-input__field {
  color: inherit;
  font-size: 1.25rem;
  height: 100%;
  outline: none;
  text-align: center;
  width: 100%;
}
:where(.vuetify-styles) .v-otp-input__field[type=number]::-webkit-outer-spin-button, :where(.vuetify-styles) .v-otp-input__field[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
:where(.vuetify-styles) .v-otp-input__field[type=number] {
  -moz-appearance: textfield;
}

:where(.vuetify-styles) .v-otp-input__loader {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}
:where(.vuetify-styles) .v-otp-input__loader .v-progress-linear {
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VOtpInput/VOtpInput.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,OAAO;AACT;AACA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".v-otp-input {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  padding: 0.5rem 0;\n  position: relative;\n}\n.v-otp-input {\n  border-radius: 4px;\n}\n.v-otp-input .v-field {\n  height: 100%;\n}\n.v-otp-input .v-field .v-field__outline__start, .v-otp-input .v-field .v-field__outline__end {\n  flex: 1;\n}\n.v-otp-input .v-field input::placeholder {\n  color: currentColor;\n  opacity: var(--v-disabled-opacity);\n}\n.v-otp-input .v-field.v-field--focused input::placeholder {\n  opacity: 0;\n}\n\n.v-otp-input__divider {\n  margin: 0 8px;\n}\n\n.v-otp-input__content {\n  align-items: center;\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  justify-content: center;\n  max-width: 320px;\n  position: relative;\n  border-radius: inherit;\n}\n.v-otp-input--divided .v-otp-input__content {\n  max-width: 360px;\n}\n\n.v-otp-input--density-default .v-otp-input__content {\n  height: 64px;\n}\n\n.v-otp-input--density-comfortable .v-otp-input__content {\n  height: 60px;\n}\n\n.v-otp-input--density-compact .v-otp-input__content {\n  height: 56px;\n}\n\n.v-otp-input__field {\n  color: inherit;\n  font-size: 1.25rem;\n  height: 100%;\n  outline: none;\n  text-align: center;\n  width: 100%;\n}\n.v-otp-input__field[type=number]::-webkit-outer-spin-button, .v-otp-input__field[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.v-otp-input__field[type=number] {\n  -moz-appearance: textfield;\n}\n\n.v-otp-input__loader {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n}\n.v-otp-input__loader .v-progress-linear {\n  position: absolute;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
